import React, { Component } from 'react';
import { components } from 'react-select';
import Async from 'react-select/async';
import { Paper, Typography, Chip, MenuItem, FormHelperText } from '@mui/material';
import { emphasize } from '@mui/material/styles';
import CancelIcon from '@mui/icons-material/Cancel';
import { Colors } from '../assets/theme/Colors';
import { getFormFieldError, isFormFieldInvalid } from '../helpers/validators';

class SelectMultiple extends Component {
  input(props) {
    const newProps = {
      ...props,
      autoComplete: 'chrome-off',
      name: props.selectProps.name,
      inputStyle: { fontSize: '16px' },
    };

    return <components.Input {...newProps} aria-invalid={props.selectProps.error} />;
  }

  option(props) {
    return (
      <MenuItem
        ref={props.innerRef}
        selected={props.isFocused}
        component="div"
        style={{
          fontWeight: props.isSelected ? 500 : 400,
        }}
        {...props.innerProps}
      >
        {props.children}
      </MenuItem>
    );
  }

  menu(props) {
    return (
      <Paper
        square
        sx={{ position: 'absolute', zIndex: 1, marginTop: 1, left: 0, right: 0 }}
        {...props.innerProps}
      >
        {props.children}
      </Paper>
    );
  }

  multiValue(props) {
    return (
      <Chip
        tabIndex={-1}
        label={props.children}
        sx={[
          {margin: `4px 2px`},
          props.isFocused && {
            backgroundColor: (theme) => emphasize(
              emphasize(theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08),
            ),
        }]}
        onDelete={props.removeProps.onClick}
        deleteIcon={<CancelIcon {...props.removeProps} />}
      />
    );
  }

  placeholder(props) {
    const { selectProps, innerProps = {}, children } = props;
    return (
      <Typography
        color="textSecondary"
        sx={{ paddingLeft: 1, position: 'absolute', left: 2, bottom: 6, fontSize: '16px' }}
        {...innerProps}
        data-testid="select-multiple-placeholder"
      >
        {children}
      </Typography>
    );
  }

  singleValue(props) {
    return (
      <components.SingleValue {...props}>
        <div data-testid="single-value">{props.data.label}</div>
      </components.SingleValue>
    );
  }

  valueContainer(props) {
    console.log( props )
    return <components.ValueContainer />
  }

  noOptionsMessage(props) {
    return (
      <Typography color="textSecondary" sx={{ py: 1, px: 2 }} {...props.innerProps}>
        {props.children}
      </Typography>
    );
  }

  render() {
    const {
      value,
      options,
      loadingMessage,
      loadOptions,
      onChange,
      selectPlaceholder,
      isMulti = true,
      onMenuOpen,
      onMenuClose,
      onBlur,
      meta,
      inputId = 'react-select-multiple',
      name,
      isDisabled = false,
    } = this.props;

    const showError = isFormFieldInvalid(meta);

    return (
      <>
        <Async
          inputId={inputId}
          name={name}
          isDisabled={isDisabled}
          styles={{
            control: (base) => ({
              ...base,
              borderColor: showError ? Colors.errorText : base.borderColor,
            }),
            singleValue: (base) => ({
              ...base,
              fontSize: '16px',
            }),
            input: (base) => ({
              ...base,
              fontSize: '16px',
            }),
            valueContainer: (base) => ({
              ...base,
              fontSize: '16px',
            }),
            placeholder: (base) => ({
              ...base,
              fontSize: '16px',
            }),
          }}
          error={showError}
          loadingMessage={loadingMessage}
          loadOptions={loadOptions}
          onMenuOpen={onMenuOpen}
          onMenuClose={onMenuClose}
          onBlur={onBlur}
          placeholder={selectPlaceholder}
          options={options}
          components={{
            Input: this.input,
            Menu: this.menu,
            MultiValue: this.multiValue,
            NoOptionsMessage: this.noOptionsMessage,
            Option: this.option,
            Placeholder: this.placeholder,
            SingleValue: this.singleValue,
          }}
          value={value}
          onChange={onChange}
          isMulti={isMulti}
          isClearable
        />
        {showError && <FormHelperText error>{getFormFieldError(meta)}</FormHelperText>}
      </>
    );
  }
}

export default SelectMultiple;
